// extracted by mini-css-extract-plugin
module.exports = {"modal":"_3FbXY","title":"_2Z5H6","description":"_3ycy8","cross":"_2e4t0","modalBackDrop":"mT9hL","content":"_2speX","timing":"EMq1N"};